module.exports = __webpack_public_path__ + "img/mon_64.c269c75e.png";